import {createRoot} from "react-dom/client";
import App from "./paleo-client/App";

const paleoClientContainer = document.getElementById('paleo-client');
if(paleoClientContainer) {
    const paleoClientRoot = createRoot(paleoClientContainer);
    paleoClientRoot.render(<App/>);
}
